import { useCallback } from 'react';
import { Close } from '@indeed/ifl-icons';
import { useDialogContext } from './context.js';
import { jsx } from '@emotion/react';
import { Button } from '../Button/Button.js';
import '@indeed/ihl-use-id';
import '../../hooks/useControllableState.js';
import '../../utils/warn.js';
import '../../hooks/useIsMobile.js';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '../IconWrapper/IconWrapper.js';

const DialogCloseButton = _ref => {
  let {
    labelClose
  } = _ref;
  const {
    isOpen,
    setOpen
  } = useDialogContext();
  const handleOnClick = useCallback(() => {
    setOpen(!isOpen);
  }, [isOpen, setOpen]);
  return jsx(Button, {
    "aria-label": labelClose,
    iconOnly: true,
    onClick: handleOnClick,
    sx: {
      marginInlineStart: "2"
    },
    type: "button",
    variant: "tertiary"
  }, jsx(Close, {
    size: "md",
    "aria-hidden": true
  }));
};
DialogCloseButton.displayName = "DialogCloseButton";

export { DialogCloseButton };
